<template>
  <el-dialog title="新建评价" :modal-append-to-body="false" :visible.sync="visible" width="50%">
    <el-form ref="formRef" :model="formData" label-width="80px" :rules="rules">
      <el-row style="margin-bottom: 0">
        <el-col :span="12">
          <el-form-item label="客户" prop="user_uuid">
            <div v-if="customer.uuid" style="display: flex; flex-direction: row; gap: 12px">
              <template v-if="customer.avatar">
                <el-image
                  style="height: 120px; width: 120px; border-radius: 50%"
                  fit="contain"
                  :src="[customer.avatar]"
                  :preview-src-list="[customer.avatar]"
                />
              </template>
              <div style="display: flex; flex-direction: column; line-height: 24px">
                <span>真名：{{ customer.real_name }}</span>
                <span>昵称：{{ customer.nick_name }}</span>
                <span>手机号：{{ customer.mobile }}</span>
              </div>
            </div>
            <el-button class="mg-l-20" @click="customerVisible = true" type="text"> + 选择客户</el-button>
            <el-checkbox class="mg-l-20" name="typexxx" v-model="formData.is_anonymous">匿名</el-checkbox>
          </el-form-item></el-col
        >
        <el-col :span="12">
          <el-form-item label="评价商品" prop="goods_uuid">
            <div v-if="commdity.uuid" style="display: flex; flex-direction: row; gap: 12px">
              <template v-if="commdity.image && commdity.image.length > 0">
                <el-image
                  style="height: 120px; width: 120px"
                  fit="contain"
                  :src="commdity.image[0].image"
                  :preview-src-list="commdity.image.map((i) => i.image)"
                />
              </template>
              <div style="display: flex; flex-direction: column; line-height: 24px">
                <span>品名：{{ commdity.name }}</span>
                <span>价格：{{ commdity.price }}</span>
                <span>规格：{{ commdity.specs.name }}</span>
                <span>库存：{{ commdity.specs.stock }}</span>
              </div>
            </div>
            <el-button type="text" @click="commdityVisible = true"> + 选择商品</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="评价时间">
        <el-date-picker
          type="datetime"
          placeholder="选择日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          v-model="formData.create_time"
        ></el-date-picker>
      </el-form-item>
      <div style="display: flex; flex-direction: row">
        <el-form-item label="质量">
          <div style="padding-top: 10px">
            <el-rate v-model="formData.score" :colors="colors"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item label="服务">
          <div style="padding-top: 10px">
            <el-rate v-model="formData.score_service" :colors="colors"> </el-rate>
          </div>
        </el-form-item>
        <el-form-item label="推荐">
          <div style="padding-top: 10px">
            <el-rate v-model="formData.score_recommend" :colors="colors"> </el-rate>
          </div>
        </el-form-item>
      </div>
      <el-form-item label="评价内容" prop="content">
        <el-input type="textarea" placeholder="请输入内容" :rows="5" v-model="formData.content"></el-input>
      </el-form-item>
      <el-form-item label="评价图片" prop="image">
        <span slot="label"><span style="color: red; display: none">*</span>评价图片</span>
        <selectImages :images.sync="formData.images" @confirm="onImages" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="visible = false">取消</el-button>
      <el-button size="mini" type="primary" @click="onSubmit()">确定</el-button>
    </span>
    <selectCommdity :visible.sync="commdityVisible" @choose="chooseCommdity" />
    <selectCustomer :isSingle="true" :dialogVisible="customerVisible" @confirmCustomer="confirmCustomer" @cancel="closeSelectCustomer" />
  </el-dialog>
</template>
<script>
  import selectCommdity from "../../../components/selectCommditySpec.vue";
  import selectImages from "../../../components/selectImages.vue";
  import selectCustomer from "../../../components/selectCustomer.vue";

  export default {
    components: {
      selectCommdity,
      selectImages,
      selectCustomer,
    },
    data() {
      return {
        visible: false,
        colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
        commdity: {},
        formData: {
          is_anonymous: false,
          score: 5,
          score_service: 5,
          score_recommend: 5,
          create_time: new Date(),
          images: [],
          content: "",
          user_uuid: "",
          goods_uuid: "",
        },
        rules: {
          user_uuid: { required: true, message: "请选择客户", trigger: "change" },
          goods_uuid: { required: true, message: "请选择商品", trigger: "change" },
          content: { required: true, message: "请输入评价内容", trigger: "blur" },
        },
        //
        commdityVisible: false,
        //
        customerVisible: false,
        customer: {},
      };
    },
    methods: {
      open({}) {
        this.visible = true;
        this.formData = {
          is_anonymous: true,
          score: 5,
          score_service: 5,
          score_recommend: 5,
          create_time: new Date(),
          images: [],
        };
        this.commdity = {};
        this.customer = {};
      },
      dismiss() {
        this.visible = false;
      },
      goodsComment(data = {}) {
        return this.axios({
          method: "post",
          data,
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: "https://time.api.boyalife.cn/v1/cms/GoodsComment",
        }).catch((err) => {
          this.$message.error(err);
        });
      },
      onSubmit() {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            // if (this.formData.images.length < 1) {
            //   this.$message.error("请至少上传一张项目图片");
            //   return false;
            // } else {

            // }
            this.$refs.formRef.validate((valid) => {
              const { create_time, is_anonymous } = this.formData;
              const params = {
                ...this.formData,
                user_uuid: this.customer.uuid,
                goods_uuid: this.commdity.uuid,
                is_anonymous: is_anonymous ? 1 : 2,
                create_time: create_time ? String(create_time).slice(0, 19).replace("T", " ") : "",
              };
              this.goodsComment(params).then(() => {
                this.$message.success("操作成功");
                this.visible = false;
                this.$emit("success");
              });
            });
          } else {
            return false;
          }
        });
      },
      chooseCommdity(data = {}) {
        console.log("chooseCommdity:", data);
        const { commidity = {}, attrs = {} } = data;
        // 选择商品后，重置评价图片
        this.formData.images = [];
        // 选择商品后，重置评价内容
        this.formData = {
          ...this.formData,
          content: "",
          goods_uuid: commidity.uuid,
          specs_uuid: attrs.uuid,
        };
        this.commdity = {
          specs: { ...attrs },
          uuid: commidity.uuid,
          code: commidity.code,
          name: commidity.name,
          stock: commidity.stock,
          price: commidity.price,
          image: [...commidity.image],
        };
      },
      //
      showPeopleDialog() {
        this.selectPeopleDialogVisible = true;
        console.log(this.selectPeopleDialogVisible);
      },
      confirmCustomer(v) {
        this.customerVisible = false;
        this.customer = Array.isArray(v) ? v[0] : v;
        //
        this.formData = {
          ...this.formData,
          user_uuid: this.customer.uuid,
        };
      },
      closeSelectCustomer(v) {
        this.customerVisible = v;
      },
      onImages() {},
    },
  };
</script>
<style scoped></style>
